import {
  AccessoriesTab,
  EditorOptionsResolvedTab,
  ResolvedTab,
  SourceTab,
  Tab,
} from "../types/ContentfulTypes";

const getUniversalContentModelTab = (
  resolvedTabs: SourceTab[],
  index: number,
  editorOptionsTab?: EditorOptionsResolvedTab
): ResolvedTab => {
  const resolvedTab = resolvedTabs[index];

  if (resolvedTab.type === "Editor Options" && editorOptionsTab) {
    return {
      type: resolvedTab.type,
      value: {
        ...editorOptionsTab,
      },
    };
  }

  return resolvedTab as ResolvedTab;
};

const getMarkdownTab = (tab: Tab) => {
  return {
    type: tab.tabType,
    value: {
      tabDetails: tab.tabDetails,
    },
  } as ResolvedTab;
};

const getFinishingOptionsTab = (tab: Tab, placeHolderImage: string) => {
  return {
    type: tab.__typename,
    value: {
      ...tab,
      placeHolderImage: placeHolderImage,
    },
  } as ResolvedTab;
};

const getDefaultTab = (tab: Tab) => {
  return {
    type: tab.__typename,
    value: tab,
  } as ResolvedTab;
};

export const showAccessoryTab = (tabData?: AccessoriesTab) => {
  const { accessoryMpvs, additionalInfo } = tabData || {};

  // If any accessory mpv has pivot property, then display this tab.
  if (additionalInfo?.find(info => !!info.pivotProperty)) {
    return true;
  }

  // Otherwise, if any accessory mpv has default image and default description, then display this tab.
  if (
    accessoryMpvs?.find(
      mpv => mpv.defaultProductDescription && mpv.defaultProductImage.cloudinaryImage.cloudinaryUrl
    )
  ) {
    return true;
  }

  return false;
};

export const createAllTabs = (props: {
  globalTabs: Tab[] | undefined;
  sourceTabs: SourceTab[];
  placeHolderImage: string;
  hideReviews: boolean | undefined;
  editorOptionsTab?: EditorOptionsResolvedTab;
}): ResolvedTab[] => {
  const { globalTabs, sourceTabs, placeHolderImage, hideReviews, editorOptionsTab } = props;
  const allTabs =
    globalTabs?.map((tab: Tab, index: number) => {
      switch (tab.__typename) {
        case "universalContentModel": {
          return getUniversalContentModelTab(sourceTabs, index, editorOptionsTab);
        }
        case "tabMarkdown": {
          return getMarkdownTab(tab);
        }
        case "tabFinishingOptions": {
          return getFinishingOptionsTab(tab, placeHolderImage);
        }
        default: {
          return getDefaultTab(tab);
        }
      }
    }) || [];
  const allTabsWithoutReviews = allTabs?.filter(tab => {
    return tab?.type !== "Reviews";
  });

  return allTabsWithoutReviews as ResolvedTab[];
};

export const tabHeaderTranslations: Record<string, string> = {
  Accessories: "accessoryTabHeader",
  Overview: "overviewTabHeader",
  tabOverview: "overviewTabHeader",
  FAQs: "faqTabHeader",
  tabFaqs: "faqTabHeader",
  "Design Specifications": "specsAndTemplatesTabHeader",
  "Finishing Options": "finishingOptionsTabHeader",
  tabFinishingOptions: "finishingOptionsTabHeader",
  Size: "sizeChartsTabHeader",
  "Editor Options": "editorOptionsTabHeader",
  Dimensions: "dimensionsTabHeader",
  "Price Chart": "priceChartTabHeader",
  "Mailing List Template": "mailingListTemplateTabHeader",
  "Mailing Service": "mailingServiceTabHeader",
};

export const tabContentTitleTranslations: Record<string, string> = {
  tabFinishingOptions: "finishingOptionsTabContentTitle",
  "Finishing Options": "finishingOptionsTabContentTitle",
};
